module.exports = __webpack_public_path__ + "img/bg_court_02.d84db8b9.jpg";